import styles from "./MenuItemHeader.module.scss";
import arrow from "../../assets/icons/arrow-right.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "../../routes/RoutePaths";

interface MenuItemHeaderProps {
  page: string;
  subtitle: string;
}

const MenuItemHeader: React.FC<MenuItemHeaderProps> = ({ page, subtitle }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.root_path}>
        <Link to={RoutePaths.HOME}>
          <p>{t("Home")}</p>
        </Link>
        <img src={arrow} alt=">" />
        <p className={styles.root_path_page}>{page}</p>
      </div>
      <h1 className={styles.root_title}>{page}</h1>
      <p className={styles.root_description}>{subtitle}</p> 
    </div>
  );
};

export default MenuItemHeader;
